import { safeParseDate, buildEmployeeEntriesFromShift, calculateShiftHours, calculateOvertimeForShift, mergeApprovedOvertimeForEmployee, mergeApprovedAbsenceForEmployee } from "./payrollCalculations";

// A project rate applies to each staffed hour, including planned shifts.
export function calculateProjectRevenue(data, projects, period) {
  const rows = projects.map(project => ({ id: project.id || project._id, name: project.name, price: project.price, hours: 0, revenue: 0 }));
  let unmatchedHours = 0;
  const employeeIds = new Set((data.employees || []).map(employee => employee.id));
  (data.shifts || []).forEach(shift => {
    const date = safeParseDate(shift.date);
    if (!date) return;
    const key = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
    if (!key.startsWith(period)) return;
    const projectId = shift.projectId || shift.project;
    const project = rows.find(row => row.id === projectId) || rows.find(row => row.name === (shift.projectName || shift.project));
    const entries = new Map(buildEmployeeEntriesFromShift(shift).map(entry => [entry.employeeId, entry.employeeData]));
    (data.bookings || []).forEach(booking => {
      if (["approved", "reserved"].includes(booking.status) && booking.userId && String(booking.originalShiftId || booking.shiftId) === String(shift.originalId || shift.id) && !entries.has(booking.userId)) {
        entries.set(booking.userId, { breaks: [], overtime: [], absences: [] });
      }
    });
    entries.forEach((entry, employeeId) => {
      if (!employeeIds.has(employeeId)) return;
      const withOvertime = mergeApprovedOvertimeForEmployee({ shift, employeeId, employeeData: entry, employees: data.employees, overtimeRules: data.overtimeRules || [], approvedOvertimeRequests: (data.overtimeRequests || []).filter(request => request.status === "approved") });
      const employeeData = mergeApprovedAbsenceForEmployee({ shift, employeeId, employeeData: withOvertime, employees: data.employees, absenceTypes: data.absenceTypes || [], approvedAbsenceRequests: (data.absenceRequests || []).filter(request => request.status === "approved") });
      const hours = calculateShiftHours(shift, employeeData) + calculateOvertimeForShift(shift, employeeData).hours;
      if (project) project.hours += hours;
      else unmatchedHours += hours;
    });
  });
  let missingPriceHours = unmatchedHours;
  rows.forEach(row => {
    const priced = row.price !== "" && row.price != null && Number.isFinite(Number(row.price)) && Number(row.price) >= 0;
    row.revenue = priced ? row.hours * Number(row.price) : null;
    if (!priced) missingPriceHours += row.hours;
  });
  return { rows, unmatchedHours, revenue: rows.reduce((sum, row) => sum + (row.revenue || 0), 0), missingPriceHours };
}
